import { ADD_TO_CART, REMOVE_FROM_CART, UPDATE_FOOD_QTY_IN_CART } from "../constants"

const initialState = {
    cart: []
}

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            return { ...state, cart: action.payload }
        case UPDATE_FOOD_QTY_IN_CART:
            return { ...state, cart: action.payload }
        case REMOVE_FROM_CART:
            return { ...state, cart: action.payload }
        default: return state
    }
}